/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFileAcrobat = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M4 2h10.414L20 7.586V22H4zm2 2v16h12V9h-5V4zm9 1.414V7h1.586z" />
        <path d="M11.56 10.745c.37-.84-.02-1.284-.037-1.278-.038.013-.519.698.037 1.278zm-.843 5.092c.815-.322 1.7-.604 2.533-.803a13.64 13.64 0 0 1-1.49-2.203 28.72 28.72 0 0 1-1.043 3.006zm4.559-.015c.09 0 .35-.004.471-.175a.622.622 0 0 0 .09-.165c-.048-.026-.112-.078-.458-.078a5.54 5.54 0 0 0-.706.043c.317.25.395.375.603.375zm-7.118 2.481c-.004.037-.015.133.168.275.058-.018.397-.176 1.029-1.366-.833.478-1.173.87-1.197 1.091zm-.218.818c-.406-.311-.46-.656-.435-.892.071-.647.856-1.324 2.334-2.014a27.025 27.025 0 0 0 1.477-4.273c-.39-.864-.767-1.984-.492-2.64.097-.23.217-.407.442-.484.09-.03.314-.068.397-.068.196 0 .369.258.492.417.115.15.375.466-.146 2.704.525 1.106 1.27 2.233 1.984 3.005.51-.094.95-.142 1.309-.142.61 0 .98.145 1.131.444.126.247.074.536-.151.859-.218.31-.517.473-.866.473-.474 0-1.026-.305-1.642-.908a18.423 18.423 0 0 0-3.442 1.122c-.326.705-.638 1.273-.93 1.69-.399.57-.744.836-1.085.836a.618.618 0 0 1-.377-.13z" />
      </g>
    </g>
  </Icon>
);
export { SvgFileAcrobat as FileAcrobat };
